/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const FronteggUserRequest = core.serialization.object({
    id: core.serialization.string(),
    email: core.serialization.string(),
    verified: core.serialization.boolean().optional(),
    roles: core.serialization.list(core.serialization.string()),
    name: core.serialization.string().optional(),
    provider: core.serialization.string(),
    tenantId: core.serialization.string(),
    tenantIds: core.serialization.list(core.serialization.string()),
    metadata: core.serialization.string().optional(),
});
